module.exports = __webpack_public_path__ + "static/ofcar3-5d53e6fc75a426db1a0051c3382a68cb.jpg";